import React, { Component } from 'react';
import Page from '../../containers/page';
import FormBuilder from '../../form-builder';
import RouteComponent from '../../helpers/route';
import ListBuilder from '../../list-builder';
import Isvg from 'react-inlinesvg';
import {
    Container,
    Row,
    Col,
    Table,
    FormGroup, Label, Input
} from 'reactstrap';
import editIcon from '../../assets/edit.svg';
import garbageIcon from '../../assets/garbage.svg';
import printIcon from '../../assets/print.svg';
import saveIcon from '../../assets/save.svg';
import DeleteModal from '../../components/deleteModal';
import { required, number, minValue, maxValue, minLength, maxLength, length, email } from '../../form-builder/validation';
class Screen extends RouteComponent {
    constructor(props) {
        super(props);
        this.state = {      
            articlesList: true,
            articleForm: false,
            total: 20,
            modules: [],
            items: [
    
            ]
        }
    }

    componentDidMount() {
       this._onLoad();
    }

    componentDidUpdate(prevProps, prevState){
        if (this.props[0].location.search != prevProps[0].location.search){
            this._onLoad();
        }
    }

    render() {
        let params = this._getParams();
        console.log(this.state)

        return (
            <div>
                <div className="section-title title-options">
                    <h1>Discount codes</h1>
                    <div className="title-options-group">
                        <button onClick={() => this.submit()}>
                            <div className="option green">
                                <Isvg src={saveIcon} />
                            </div>
                            <span>Save</span>
                        </button>
                    </div>
                </div>

                <Container fluid style={{ paddingRight: 0 }}>
                <DeleteModal
                        isOpen={this.state.deleteModal}
                        toggle={() => this.setState({ deleteModal: null })}
                        handler={() => {
                            this._api('api3', { data: this.state.deleteModal._id }, () => {
                                this.setState({ groupsForm:{} }, () => { this._onLoad();this.setState({ deleteModal: null }) })
                            });
                        }} >
                        Delete discount code <strong>{this.state.deleteModal ? this.state.deleteModal.name:''}</strong> ?
                </DeleteModal>
                    <Row>
                        <Col lg="6">                            
                            <FormBuilder
                             registerSubmitAction={(submit) => this.submit = submit}
                                classNameForm={"add-form-container"}
                                // headerForm={"Article".translate(this.props.lang)}
                                addButtonText={'Add'.translate(this.props.lang)}
                                    onSubmit={(dat) => {
                                        
                                        let data = {...dat};

                                       
    
                                        if (this.state.form && this.state.form._id) {
                                           
                                            this._api('api4', { data: data }, () => {
                                                this.setState({ form: undefined }, () => { this._onLoad(); })
                                            });
                                        } else {
    
                                            this._api('api2', { data: data }, () => {
                                                this.setState({ clientForm: {} }, () => { this._onLoad() })
                                            });
                                        }
                                    }}
                                    initialValues={this.state.form ? this.state.form : null}
                                    fields={[
                                        {
                                            type: 'row',
                                            children: [
                                                {
                                                    type: 'col',
                                                    width: { lg: 12, sm: 12, xs: 12 },
                                                    children: [
                                                        {
                                                            type: 'block',
                                                            header: 'Discount code'.translate(this.props.lang),
                                                            children: [
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 6, xs: 6 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'code',
                                                                            next: 'level',
                                                                            label: 'Code',
                                                                            asyncValidation: true,
                                                                            validate: [
                                                                                required('Required!'),
                                                                            ]
                                                                        },
                        
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 6, xs: 6 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            textType: 'number',
                                                                            name: 'discount',
                                                                            next: 'level',
                                                                            label: 'Discount',
                                                                            asyncValidation: true,
                                                                            validate: [
                                                                                required('Required!'),
                                                                            ]
                                                                        },
                        
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 6, xs: 6 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            textType: 'date',
                                                                            name: 'dateFrom',
                                                                            next: 'level',
                                                                            label: 'Valid from',
                                                                            asyncValidation: true,
                                                                            validate: [
                                                                                required('Required!'),
                                                                            ]
                                                                        },
                        
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 6, xs: 6 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            textType: 'date',
                                                                            name: 'dateTo',
                                                                            next: 'level',
                                                                            label: 'Valid to',
                                                                            asyncValidation: true,
                                                                            validate: [
                                                                                required('Required!'),
                                                                            ]
                                                                        },
                        
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 12, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'switch',
                                                                            name: 'isGiftCard',
                                                                            label: 'Is Gift Card',
                                                                        },
                                                                    ]
                                                                },


                                                                
                                                            ]
                                                        },

                                                    ]
                                                }
                                            ]
                                        },
                                        
                                        
                                    ]}
                            ></FormBuilder>
                        </Col>
                        <Col lg="6">
                            <div className="table-modifed ml-15">
                                <ListBuilder
                                    tabs={false}
                                    sort={false}
                                    header={'List'}
                                    lang={this.props.lang}
                                    loading={this.state.loading}
                                    total={this.state.total}
                                    showNumeration={false}
                                    fields={[
                                        { type: 'text', name: 'code', label: 'CODE'.translate(this.props.lang), multilang: false, allowSort: true },
                                        { type: 'text', name: 'discount', label: 'DISCOUNT [%]'.translate(this.props.lang), multilang: false, allowSort: true },
                                        { type: 'text', name: 'used', label: 'USED'.translate(this.props.lang), multilang: false, allowSort: true },

                                    ]}
                                    items={this.state.items.map((item) => {
                                        return {
                                            ...item,
                                            used: item.used ? 'YES' : 'NO'
                                        }
                                    })}
                                    rawItems={this.state.items}
                                    actions={
                                        [
                                            {
                                                component: <Isvg src={editIcon} className="delete-icon" />,
                                                onClick: (item) => {

                                                 


                                                     this.setState({ form: null }, () => this.setState({form: item}))

                                                }
                                                //onClick: (item) => console.log(item)
                                            },
                                            {
                                                component: <Isvg src={garbageIcon} className="delete-icon" />,
                                                onClick: (item) => this.setState({ deleteModal: item })
                                            },
                                        ]
                                    }
                                    params={params}
                                    sortField={params.sortField}
                                    sortType={params.sortType}
                                    updateSort={this.updateSort}
                                    updateParams={this.updateParams}
                                    updateMultipleParams={this.updateMultipleParams}
                                ></ListBuilder>
                             </div>
                        </Col>
                    </Row>
                </Container>

            </div>
        )
    }
}

export default Page(Screen);
